module.exports = __webpack_public_path__ + "static/media/MaritimeLaw.c8709253.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/MaritimeLaw.PNG
// module id = 1369
// module chunks = 1